import React from "react";
import Carousel from "./Carousel";

const SideBar = (props) => (
        <div className="col-md-3">
            <Carousel images={props.instaArray}/>
        </div>
    )

export default SideBar;